<script>
    import { mostrarSidebar } from "../../MainStore.js";
    import { Navigate } from 'svelte-router-spa'

    const ocultarSidebar = $mostrarSidebar ? "" : "d-none";
</script>

<nav id="sidebar" class={ocultarSidebar}>
    <div class="sidebar-header">
        <a href="/"><img alt="Logo" src="/logo.svg" /></a>
    </div>

    <div style={{overflow: "auto"}}>
        <ul class="list-unstyled components mt-2">
            <li class="active">
                <Navigate to="/">Tablero</Navigate>
            </li>
            <li>
                <Navigate to="/alumnos">Alumnos</Navigate>
            </li>
            <li>
                <a href="/">Materias</a>
            </li>
            <li>
                <Navigate to="configuracion">Configuracion</Navigate>
            </li>
        </ul>
    </div>

    <a href="/">
        <div class="user-block row">
            <div class="col-4 img-responsive">
                <img alt="" src="/logo.svg" />
            </div>
            <div class="col-8">
                <div>
                    <h2>Preceptora Maria Eugenia</h2>
                </div>
            </div>
        </div>
    </a>
</nav>